// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"25040cbb","453":"ba721033"}[chunkId] + ".chunk.js";
};